import PropTypes from "prop-types";
import React from "react";
import "./VehicleStateDisplay.css";

export default function VehicleStateDisplay({ className, vehicleState, stateLabel }) {

  return (
    <div className={`vehicleStateDisplay ${vehicleState === stateLabel.toLowerCase()? 'on' : 'off'} ${className}`}>
      <div className="frame">
        <div className="stateText">{stateLabel}</div>
      </div>
    </div>
  );
}

VehicleStateDisplay.propTypes = {
  vehicleState: PropTypes.string.isRequired,
  stateLabel: PropTypes.oneOf(["Emergency", "Parking", "Driving", "Autonomous", "Maintenance"]).isRequired,
};
